import React from "react";
import Home from "../../pages/home/Home";
import Projects from "../../pages/projects/Projects";
import AboutMe from "../../pages/aboutMe/AboutMe";
import Contact from "../../pages/contact/Contact";
import ProjectDetails from "../../pages/projects/projectDetails/ProjectDetails";

// const Home= React.lazy(() => import("../../pages/home/Home"));
// const Projects = React.lazy(() => import("../../pages/projects/Projects"));
// const AboutMe = React.lazy(() => import("../../pages/aboutMe/AboutMe"));
// const Contact = React.lazy(() => import("../../pages/contact/Contact"));
// const ProjectDetails = React.lazy(() => import("../../pages/projects/projectDetails/ProjectDetails"));

export const ROUTES = [
    { 
        path: "/",
        element: <Home />
    },
    { 
        path: "/Projects",
        element: <Projects />
    },
    { 
        path: "/AboutMe",
        element: <AboutMe />
    },
    { 
        path: "/Contact",
        element: <Contact />
    },
    { 
        path: "/ProjectDetails",
        element: <ProjectDetails />
    },
];

export default ROUTES;